<template>
    <div id="deco-homes-wrapper">
        <div id="deco-portfolio">
            <PortfolioHeader 
                :pageName="pageName"
                :disciplines="disciplines" 
                :services="services"
                :pageLink="pageLink"
                :linkName="linkName"
            />
            <section class="bg-black text-white">
                <b-container class="py-100">
                    <p class="gotham-bold">
                        WEBSITE
                    </p>
                    <p class="gotham-book mb-0">
                        Cetana, both in its literal definition and corporate philosophy, urges the mind to move toward a particular objective. In this case, it's to reimagine community development through the lens of sustainability and wellness. Every element of Cetana's website works in harmony to express this idea – courtesy of 1063.
                    </p>
                </b-container>
            </section>
            <section>
                <FullWidthSliderWithColumns 
                :slides="sliderWithColumns"
                :styles="sliderWithColumnsStyles"/>
            </section>
            <section>
                <b-row class="overflow-hidden">
                    <b-col cols="3" class="px-0">
                        <img src="/img/portfolio/cetana/cetana-stipple-texture-text.jpg" alt="Cetana - Textured" class="d-block w-100 h-120 object-fit-cover">
                    </b-col>
                    <b-col cols="9" class="px-0">
                        <img src="/img/portfolio/cetana/cetana-inspired.jpg" alt="Cetana - Inspired" class="d-block w-100">
                    </b-col>
                    <b-col cols="9" class="px-0">
                        <img src="/img/portfolio/cetana/cetana-by.jpg" alt="Cetana - By" class="d-block w-100">
                    </b-col>
                    <b-col cols="3" class="px-0">
                        <img src="/img/portfolio/cetana/cetana-stipple-texture-no-text.jpg" alt="Cetana - Textured" class="d-block w-100 h-120 object-fit-cover">
                    </b-col>
                    <b-col cols="3" class="px-0">
                        <img src="/img/portfolio/cetana/cetana-stipple-texture-no-text.jpg" alt="Cetana - Textured" class="d-block w-100 h-120 object-fit-cover">
                    </b-col>
                    <b-col cols="9" class="px-0">
                        <img src="/img/portfolio/cetana/cetana-nature.jpg" alt="Cetana - Nature" class="d-block w-100">
                    </b-col>
                </b-row>
            </section>
            
            <section>
                <img src="/img/portfolio/cetana/cetana-environment.jpg" alt="Cetana" class="d-block w-100">
            </section>
            <section>
                <ImageAndTextPortfolio 
                    :imageAndTextContent="imageAndTextContent"
                />
            </section>
            <section>
                <img src="/img/portfolio/cetana/cetana-business-cards.jpg" alt="Cetana Business Cards" class="d-block w-100">
            </section>
            <section>
                <FullWidthSlider 
                :slides="firstSliderItems"
                :styles="firstSliderStyles"/>
            </section>
            <section>
                <img src="/img/portfolio/cetana/cetana-signage.jpg" alt="Cetana Signage" class="d-block w-100">
            </section>
            <section class="conclusion">
                <b-container class="next-project stipple-bg py-5" fluid>
                    <NextProject :nextProject="nextProject"/>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
        <!-- <div>
            <FullWidthSlider2 
            :slides="secondSliderItems"
            :styles="secondSliderStyles"/>
        </div> -->
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    head: {
      title: "Guidelines Advertising Inc - 1063 Eglinton Ave",
      meta: [
        {
            hid: "description",
            content:
            "Guidelines Advertising is a full-service real estate marketing company with over 35 years experience in Toronto, Ontario, Canada."
        },
        { 
            hid: 'keywords', 
            name: 'keywords', 
            content: 'Toronto,Real estate décor consulting Toronto, real estate, marketing, toronto, branding, social media, web development, interior design, print, advertising, content marketing, eglinton'
        }
      ]
    },
    data() {
        return {
            scrollSmoother_decoHomes: null,
            textAnimation_decoHomes: null,
            fadeInUpElement_decoHomes: null,
            disciplines: [
                {
                    name: "real estate development"
                }
            ],
            services: [
                {
                    name: "web design"
                },
                {
                    name: "web development"
                },
                {
                    name: "social media"
                },
                {
                    name: "account management"
                },
                {
                    name: "brochure design"
                },
                {
                    name: "magazine writing"
                },
                {
                    name: "magazine design"
                },
                {
                    name: "truck design"
                }
            ],
            pageName: "Cetana",
            pageLink: "",
            linkName: "",
            sliderWithColumns: [
                {
                    img: "/img/portfolio/cetana/cetana-logo-over-green-texture.jpg",
                    alt: "Cetana",
                    imgLeft: "/img/portfolio/cetana/cetana-grey-logo-green-bg.jpg",
                    imgRight: "/img/portfolio/cetana/cetana-white-logo-orange-bg.jpg",
                }
            ],
            sliderWithColumnsStyles: {
                bgColor: '#e7e4dc',
                textColor: '#000',
                sliderClass: 'slider-dots-black',
                imgOnLeftSide: true,
                heading: "CORPORATE INITIATIVES",
                desc: "Cetana embraces a litany of corporate initiatives to create a new standard of community development. Their commitment to addressing growing and diversified populations, flexible lifestyles, impacts of climate change, local economic development, and positive technical integration are but a few ways in which Cetana sparks community-wide change across Canada.",
                subheading: ''
            },
            fullWidthSliderImages: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-1.jpg",
                    alt: "DECO Magazie"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-2.jpg",
                    alt: "DECO Magazie"
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-magazine-3.jpg",
                    alt: "DECO Magazie"
                }
            ],
            firstSliderStyles: {
                bgColor: '#586961',
                textColor: '#fff',
                sliderClass: false,
                imgOnLeftSide: false,
                heading: "SIGNAGE",
                desc: "We took Cetana's identity as true thought leaders and put it front and centre for all to see. They inspire responsible leadership, positive community action, and tangible change across Canada. In doing so, they protect our future. That's why they're here. Plain and simple.",
                subheading: ''
            },
            firstSliderItems: [
                {
                    img: "/img/portfolio/cetana/cetana-here-for-the-future.jpg",
                    alt: "Cetana - Here For The Future"
                }
            ],
            secondSliderStyles: {
                bgColor: '#000',
                textBackgroundImg: 'stipple-bg',
                imgOnLeftSide: false,
                imgPadding: false,
                textColor: 'text-black',
                sliderClass: false,
                heading: "GUERILLA MARKETING CAMPAIGN",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                subheading: ''
            },
            secondSliderItems: [
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                },
                {
                    img: "/img/portfolio/deco/slider/ga-fullwidth-slider-deco-concierge.jpg",
                    heading: "CORPORATE INITIATIVES",
                    desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna",
                    subheading: 'DECO CONCIERGE'
                }
            ],
            imageAndTextContent: {
                imgOnLeftSide: false,
                imgPadding: true,
                bgColor: '#202620',
                bgImageClass: "",
                textColor: "#fff",
                img: "/img/portfolio/cetana/cetana-harnessing-nature.jpg",
                alt: "Harnessing the Power of Nature",
                heading: "ETHOS",
                desc: "Cetana's ethos influences everything they do – from pushing the boundaries of green building to clean energy infrastructure initiatives, sparking sustainable market transformations, and beyond. Their team and corporate partners have been at the forefront of Canada's sustainability movement for decades and continue to raise the standards of responsible design today."
            },
            secondImageAndTextContent: {
                imgOnLeftSide: false,
                imgPadding: false,
                bgColor: '#e7e4dc',
                bgImageClass: "",
                textColor: "#000",
                img: "/img/portfolio/deco/deco-tiktok-placeholder.jpg",
                alt: "DECO Magazine Design Trends",
                heading: "SOCIAL MEDIA",
                desc: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna"
            },
            nextProject: {
                link: "/portfolio/the-underground",
                name: "The Underground"
            }
        }
    },
    components: {
        PortfolioHeader: () => import('@/components/PortfolioHeader'),
        FullWidthSliderWithColumns: () => import('@/components/FullWidthSliderWithColumns'),
        FullWidthSlider: () => import('@/components/FullWidthSlider'),
        FullWidthSlider2: () => import('@/components/FullWidthSlider2'),
        ImageAndTextPortfolio: () => import('@/components/ImageAndTextPortfolio'),
        FullWidthImageSlider: () => import('@/components/FullWidthImageSlider'),
        Transition1063: () => import('@/components/Transition1063'),
        NextProject: () => import('@/components/NextProject'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_decoHomes();
            // 
            this.initImgElReveal_decoHomes();
            this.initTextReveal_decoHomes();
        }, 500)
    },
    methods: {
        initscrollSmoother_decoHomes() {
            this.scrollSmoother_decoHomes = ScrollSmoother.create({
                wrapper: '#deco-homes-wrapper',
                content: "#deco-portfolio",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_decoHomes.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_decoHomes() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_decoHomes = this.fadeInUpElement_decoHomes;
                fadeInUpElement_decoHomes = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_decoHomes.set(container, { autoAlpha: 1 });
                fadeInUpElement_decoHomes.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
        initTextReveal_decoHomes() {
            let revealText = document.querySelectorAll(".reveal-text");
            revealText.forEach((container) => {
                let textAnimation_decoHomes = this.textAnimation_decoHomes;
                textAnimation_decoHomes = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.1
                    }
                });

                var splitHide = new SplitText(container, { type: "words", wordsClass: "hide-text" });
                var split = new SplitText(container, {
                    type: "words,lines",
                    wordsClass: "words",
                    linesClass: "lines"
                });
                textAnimation_decoHomes.set(container, { autoAlpha: 1 });
                textAnimation_decoHomes.from(split.words, {
                    delay: 0.5,
                    duration: 0.35,
                    yPercent: 100,
                    stagger: 0.03,
                    ease: 'power2.out'
                });
            })
        }
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_decoHomes.kill();
        }, 500)
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables';

</style>